import { useTranslation } from 'react-i18next';

import type { GraphQLContactPreference } from '@sola/schema/dotcom/supporters/schema.generated.ts';

import {
  ContactPreferenceChannel,
  isContactPreferenceChannelEditable,
} from '../../utils/contact-preferences.ts';

const hasEditablePreference = (
  categories: string[] | null | undefined,
  channel: ContactPreferenceChannel,
): boolean =>
  categories?.some((category) =>
    isContactPreferenceChannelEditable(category, channel),
  ) ?? false;

export const useComponentContactCard = (
  preferences?: GraphQLContactPreference | null,
) => {
  const { t } = useTranslation(['my-settings']);

  const isDoNotContact = preferences?.doNotContact ?? false;
  const isDoNotEmail = preferences?.doNotEmail ?? false;
  const isDoNotText = preferences?.doNotText ?? false;

  const emailPart = hasEditablePreference(
    preferences?.emailInterestCategories,
    ContactPreferenceChannel.Email,
  )
    ? t('my-settings:contactCard.preferencesSummary.someEmail')
    : t('my-settings:contactCard.preferencesSummary.noEmail');

  const textPart = hasEditablePreference(
    preferences?.textInterestCategories,
    ContactPreferenceChannel.Text,
  )
    ? t('my-settings:contactCard.preferencesSummary.someText')
    : t('my-settings:contactCard.preferencesSummary.noText');

  return {
    emailPart,
    textPart,
    isDoNotContact,
    isDoNotEmail,
    isDoNotText,
  };
};
